import {
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
} from './ULong.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { contains2ejsq2kq1axf2 as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from './js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ULongArray___init__impl__twm1l3(storage) {
  return storage;
}
function _ULongArray___get_storage__impl__28e64j($this) {
  return $this;
}
function _ULongArray___init__impl__twm1l3_0(size) {
  return _ULongArray___init__impl__twm1l3(new BigInt64Array(size));
}
function ULongArray__get_impl_pr71q9($this, index) {
  // Inline function 'kotlin.toULong' call
  var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
  return _ULong___init__impl__c78o9k(this_0);
}
function ULongArray__set_impl_z19mvh($this, index, value) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  tmp[index] = _ULong___get_data__impl__fggpzb(value);
}
function _ULongArray___get_size__impl__ju6dtr($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length;
}
function ULongArray__iterator_impl_cq4d2h($this) {
  return new (Iterator())(_ULongArray___get_storage__impl__28e64j($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.su_1 = array;
        this.tu_1 = 0;
      }
      q1() {
        return this.tu_1 < this.su_1.length;
      }
      uu() {
        var tmp;
        if (this.tu_1 < this.su_1.length) {
          var _unary__edvuaz = this.tu_1;
          this.tu_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toULong' call
          var this_0 = this.su_1[_unary__edvuaz];
          tmp = _ULong___init__impl__c78o9k(this_0);
        } else {
          throw NoSuchElementException().a2(this.tu_1.toString());
        }
        return tmp;
      }
      r1() {
        return new (ULong())(this.uu());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function ULongArray__contains_impl_v9bgai($this, element) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
  return contains(tmp, tmp$ret$0);
}
function ULongArray__contains_impl_v9bgai_0($this, element) {
  if (!(element instanceof ULong()))
    return false;
  return ULongArray__contains_impl_v9bgai($this.vu_1, element instanceof ULong() ? element.qu_1 : THROW_CCE());
}
function ULongArray__containsAll_impl_xx8ztf($this, elements) {
  var tmp0 = isInterface(elements, Collection()) ? elements : THROW_CCE();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp_0;
      if (element instanceof ULong()) {
        var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = element.qu_1;
        var tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = contains(tmp_1, tmp$ret$2);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
  return ULongArray__containsAll_impl_xx8ztf($this.vu_1, elements);
}
function ULongArray__isEmpty_impl_c3yngu($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length === 0;
}
function ULongArray__toString_impl_wqk1p5($this) {
  return 'ULongArray(storage=' + toString($this) + ')';
}
function ULongArray__hashCode_impl_aze4wa($this) {
  return hashCode($this);
}
function ULongArray__equals_impl_vwitwa($this, other) {
  if (!(other instanceof ULongArray()))
    return false;
  var tmp0_other_with_cast = other.vu_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ULongArrayClass;
function ULongArray() {
  if (ULongArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.vu_1 = storage;
      }
      q2() {
        return _ULongArray___get_size__impl__ju6dtr(this.vu_1);
      }
      p1() {
        return ULongArray__iterator_impl_cq4d2h(this.vu_1);
      }
      wu(element) {
        return ULongArray__contains_impl_v9bgai(this.vu_1, element);
      }
      t2(element) {
        return ULongArray__contains_impl_v9bgai_0(this, element);
      }
      xu(elements) {
        return ULongArray__containsAll_impl_xx8ztf(this.vu_1, elements);
      }
      q4(elements) {
        return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
      }
      n1() {
        return ULongArray__isEmpty_impl_c3yngu(this.vu_1);
      }
      toString() {
        return ULongArray__toString_impl_wqk1p5(this.vu_1);
      }
      hashCode() {
        return ULongArray__hashCode_impl_aze4wa(this.vu_1);
      }
      equals(other) {
        return ULongArray__equals_impl_vwitwa(this.vu_1, other);
      }
    }
    initMetadataForClass($, 'ULongArray', VOID, VOID, [Collection()]);
    ULongArrayClass = $;
  }
  return ULongArrayClass;
}
//region block: exports
export {
  _ULongArray___init__impl__twm1l3_0 as _ULongArray___init__impl__twm1l3306egki9v2xvq,
  _ULongArray___init__impl__twm1l3 as _ULongArray___init__impl__twm1l311m1vqktvg80l,
  ULongArray__get_impl_pr71q9 as ULongArray__get_impl_pr71q91094qpdno4ge1,
  ULongArray__set_impl_z19mvh as ULongArray__set_impl_z19mvh3hfs4gnea82kx,
  _ULongArray___get_size__impl__ju6dtr as _ULongArray___get_size__impl__ju6dtr313kllzk1pm23,
  _ULongArray___get_storage__impl__28e64j as _ULongArray___get_storage__impl__28e64jn29edyvk0vk2,
  ULongArray as ULongArray3nd0d80mdwjj8,
};
//endregion

//# sourceMappingURL=ULongArray.mjs.map
